import { APlayer } from '@moefe/vue-aplayer';
export default {
  name: "musicPlayer",
  components: {
    APlayer: APlayer
  },
  data: function data() {
    return {
      audio: []
    };
  }
};